// This file is auto-generated by @hey-api/openapi-ts

import { type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { acceptInvitation, approvePayment, archiveCounterparty, cancelPayment, createCounterparty, createInvitation, createOrg, createPayment, getAccountStatement, getApprovalPolicy, getCounterparty, getMe, getOnboarding, getOrg, getPayment, getPaymentLimits, listAccounts, listActivity, listCounterparties, listFundingInstruments, listInvitations, listMembers, listPayments, listRoles, type Options, putApprovalPolicy, quotePayment, rejectPayment, removeMember, revokeInvitation, saveOnboarding, simulateDeposit, submitOnboarding, submitOnboardingDocuments, updateMember, updateOrg, uploadOnboardingDocument } from '../sdk.gen';
import type { AcceptInvitationData, AcceptInvitationError, AcceptInvitationResponse, ApprovePaymentData, ApprovePaymentError, ApprovePaymentResponse, ArchiveCounterpartyData, ArchiveCounterpartyError, ArchiveCounterpartyResponse, CancelPaymentData, CancelPaymentError, CancelPaymentResponse, CreateCounterpartyData, CreateCounterpartyError, CreateCounterpartyResponse, CreateInvitationData, CreateInvitationError, CreateInvitationResponse, CreateOrgData, CreateOrgError, CreateOrgResponse, CreatePaymentData, CreatePaymentError, CreatePaymentResponse, GetAccountStatementData, GetAccountStatementError, GetAccountStatementResponse, GetApprovalPolicyData, GetApprovalPolicyError, GetApprovalPolicyResponse, GetCounterpartyData, GetCounterpartyError, GetCounterpartyResponse, GetMeData, GetMeError, GetMeResponse, GetOnboardingData, GetOnboardingError, GetOnboardingResponse, GetOrgData, GetOrgError, GetOrgResponse, GetPaymentData, GetPaymentError, GetPaymentLimitsData, GetPaymentLimitsError, GetPaymentLimitsResponse, GetPaymentResponse, ListAccountsData, ListAccountsError, ListAccountsResponse, ListActivityData, ListActivityError, ListActivityResponse, ListCounterpartiesData, ListCounterpartiesError, ListCounterpartiesResponse, ListFundingInstrumentsData, ListFundingInstrumentsError, ListFundingInstrumentsResponse, ListInvitationsData, ListInvitationsError, ListInvitationsResponse, ListMembersData, ListMembersError, ListMembersResponse, ListPaymentsData, ListPaymentsError, ListPaymentsResponse, ListRolesData, ListRolesError, ListRolesResponse, PutApprovalPolicyData, PutApprovalPolicyError, PutApprovalPolicyResponse, QuotePaymentData, QuotePaymentError, QuotePaymentResponse, RejectPaymentData, RejectPaymentError, RejectPaymentResponse, RemoveMemberData, RemoveMemberError, RemoveMemberResponse, RevokeInvitationData, RevokeInvitationError, RevokeInvitationResponse, SaveOnboardingData, SaveOnboardingError, SaveOnboardingResponse, SimulateDepositData, SimulateDepositError, SimulateDepositResponse, SubmitOnboardingData, SubmitOnboardingDocumentsData, SubmitOnboardingDocumentsError, SubmitOnboardingDocumentsResponse, SubmitOnboardingError, SubmitOnboardingResponse, UpdateMemberData, UpdateMemberError, UpdateMemberResponse, UpdateOrgData, UpdateOrgError, UpdateOrgResponse, UploadOnboardingDocumentData, UploadOnboardingDocumentError, UploadOnboardingDocumentResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getMeQueryKey = (options?: Options<GetMeData>) => createQueryKey('getMe', options);

export const getMeOptions = (options?: Options<GetMeData>) => queryOptions<GetMeResponse, GetMeError, GetMeResponse, ReturnType<typeof getMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMeQueryKey(options)
});

export const createOrgMutation = (options?: Partial<Options<CreateOrgData>>): UseMutationOptions<CreateOrgResponse, CreateOrgError, Options<CreateOrgData>> => {
    const mutationOptions: UseMutationOptions<CreateOrgResponse, CreateOrgError, Options<CreateOrgData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createOrg({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOrgQueryKey = (options: Options<GetOrgData>) => createQueryKey('getOrg', options);

export const getOrgOptions = (options: Options<GetOrgData>) => queryOptions<GetOrgResponse, GetOrgError, GetOrgResponse, ReturnType<typeof getOrgQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrg({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrgQueryKey(options)
});

export const updateOrgMutation = (options?: Partial<Options<UpdateOrgData>>): UseMutationOptions<UpdateOrgResponse, UpdateOrgError, Options<UpdateOrgData>> => {
    const mutationOptions: UseMutationOptions<UpdateOrgResponse, UpdateOrgError, Options<UpdateOrgData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateOrg({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listMembersQueryKey = (options: Options<ListMembersData>) => createQueryKey('listMembers', options);

export const listMembersOptions = (options: Options<ListMembersData>) => queryOptions<ListMembersResponse, ListMembersError, ListMembersResponse, ReturnType<typeof listMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMembersQueryKey(options)
});

export const removeMemberMutation = (options?: Partial<Options<RemoveMemberData>>): UseMutationOptions<RemoveMemberResponse, RemoveMemberError, Options<RemoveMemberData>> => {
    const mutationOptions: UseMutationOptions<RemoveMemberResponse, RemoveMemberError, Options<RemoveMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateMemberMutation = (options?: Partial<Options<UpdateMemberData>>): UseMutationOptions<UpdateMemberResponse, UpdateMemberError, Options<UpdateMemberData>> => {
    const mutationOptions: UseMutationOptions<UpdateMemberResponse, UpdateMemberError, Options<UpdateMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listRolesQueryKey = (options: Options<ListRolesData>) => createQueryKey('listRoles', options);

export const listRolesOptions = (options: Options<ListRolesData>) => queryOptions<ListRolesResponse, ListRolesError, ListRolesResponse, ReturnType<typeof listRolesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listRoles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listRolesQueryKey(options)
});

export const listInvitationsQueryKey = (options: Options<ListInvitationsData>) => createQueryKey('listInvitations', options);

export const listInvitationsOptions = (options: Options<ListInvitationsData>) => queryOptions<ListInvitationsResponse, ListInvitationsError, ListInvitationsResponse, ReturnType<typeof listInvitationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listInvitations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listInvitationsQueryKey(options)
});

export const createInvitationMutation = (options?: Partial<Options<CreateInvitationData>>): UseMutationOptions<CreateInvitationResponse, CreateInvitationError, Options<CreateInvitationData>> => {
    const mutationOptions: UseMutationOptions<CreateInvitationResponse, CreateInvitationError, Options<CreateInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const revokeInvitationMutation = (options?: Partial<Options<RevokeInvitationData>>): UseMutationOptions<RevokeInvitationResponse, RevokeInvitationError, Options<RevokeInvitationData>> => {
    const mutationOptions: UseMutationOptions<RevokeInvitationResponse, RevokeInvitationError, Options<RevokeInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokeInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const acceptInvitationMutation = (options?: Partial<Options<AcceptInvitationData>>): UseMutationOptions<AcceptInvitationResponse, AcceptInvitationError, Options<AcceptInvitationData>> => {
    const mutationOptions: UseMutationOptions<AcceptInvitationResponse, AcceptInvitationError, Options<AcceptInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await acceptInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApprovalPolicyQueryKey = (options: Options<GetApprovalPolicyData>) => createQueryKey('getApprovalPolicy', options);

export const getApprovalPolicyOptions = (options: Options<GetApprovalPolicyData>) => queryOptions<GetApprovalPolicyResponse, GetApprovalPolicyError, GetApprovalPolicyResponse, ReturnType<typeof getApprovalPolicyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApprovalPolicy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApprovalPolicyQueryKey(options)
});

export const putApprovalPolicyMutation = (options?: Partial<Options<PutApprovalPolicyData>>): UseMutationOptions<PutApprovalPolicyResponse, PutApprovalPolicyError, Options<PutApprovalPolicyData>> => {
    const mutationOptions: UseMutationOptions<PutApprovalPolicyResponse, PutApprovalPolicyError, Options<PutApprovalPolicyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApprovalPolicy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listActivityQueryKey = (options: Options<ListActivityData>) => createQueryKey('listActivity', options);

export const listActivityOptions = (options: Options<ListActivityData>) => queryOptions<ListActivityResponse, ListActivityError, ListActivityResponse, ReturnType<typeof listActivityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listActivity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listActivityQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const listActivityInfiniteQueryKey = (options: Options<ListActivityData>): QueryKey<Options<ListActivityData>> => createQueryKey('listActivity', options, true);

export const listActivityInfiniteOptions = (options: Options<ListActivityData>) => {
    const opts = infiniteQueryOptions<ListActivityResponse, ListActivityError, InfiniteData<ListActivityResponse>, QueryKey<Options<ListActivityData>>, string | Pick<QueryKey<Options<ListActivityData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListActivityData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    before: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listActivity({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listActivityInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listAccountsQueryKey = (options: Options<ListAccountsData>) => createQueryKey('listAccounts', options);

export const listAccountsOptions = (options: Options<ListAccountsData>) => queryOptions<ListAccountsResponse, ListAccountsError, ListAccountsResponse, ReturnType<typeof listAccountsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAccounts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAccountsQueryKey(options)
});

export const getAccountStatementQueryKey = (options: Options<GetAccountStatementData>) => createQueryKey('getAccountStatement', options);

export const getAccountStatementOptions = (options: Options<GetAccountStatementData>) => queryOptions<GetAccountStatementResponse, GetAccountStatementError, GetAccountStatementResponse, ReturnType<typeof getAccountStatementQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAccountStatement({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAccountStatementQueryKey(options)
});

export const getAccountStatementInfiniteQueryKey = (options: Options<GetAccountStatementData>): QueryKey<Options<GetAccountStatementData>> => createQueryKey('getAccountStatement', options, true);

export const getAccountStatementInfiniteOptions = (options: Options<GetAccountStatementData>) => {
    const opts = infiniteQueryOptions<GetAccountStatementResponse, GetAccountStatementError, InfiniteData<GetAccountStatementResponse>, QueryKey<Options<GetAccountStatementData>>, string | Pick<QueryKey<Options<GetAccountStatementData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetAccountStatementData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    before: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getAccountStatement({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAccountStatementInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listFundingInstrumentsQueryKey = (options: Options<ListFundingInstrumentsData>) => createQueryKey('listFundingInstruments', options);

export const listFundingInstrumentsOptions = (options: Options<ListFundingInstrumentsData>) => queryOptions<ListFundingInstrumentsResponse, ListFundingInstrumentsError, ListFundingInstrumentsResponse, ReturnType<typeof listFundingInstrumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFundingInstruments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFundingInstrumentsQueryKey(options)
});

/**
 * Sandbox only. Asks the partner's test environment to send funds to the account's virtual account.
 */
export const simulateDepositMutation = (options?: Partial<Options<SimulateDepositData>>): UseMutationOptions<SimulateDepositResponse, SimulateDepositError, Options<SimulateDepositData>> => {
    const mutationOptions: UseMutationOptions<SimulateDepositResponse, SimulateDepositError, Options<SimulateDepositData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await simulateDeposit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPaymentsQueryKey = (options: Options<ListPaymentsData>) => createQueryKey('listPayments', options);

export const listPaymentsOptions = (options: Options<ListPaymentsData>) => queryOptions<ListPaymentsResponse, ListPaymentsError, ListPaymentsResponse, ReturnType<typeof listPaymentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPayments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPaymentsQueryKey(options)
});

export const listPaymentsInfiniteQueryKey = (options: Options<ListPaymentsData>): QueryKey<Options<ListPaymentsData>> => createQueryKey('listPayments', options, true);

export const listPaymentsInfiniteOptions = (options: Options<ListPaymentsData>) => {
    const opts = infiniteQueryOptions<ListPaymentsResponse, ListPaymentsError, InfiniteData<ListPaymentsResponse>, QueryKey<Options<ListPaymentsData>>, number | Pick<QueryKey<Options<ListPaymentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListPaymentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listPayments({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPaymentsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Sends money to a recipient. The amount plus fee is reserved immediately; payments above the approval threshold wait for approvers. Requires two-factor authentication. Retrying with the same Idempotency-Key returns the original payment.
 *
 */
export const createPaymentMutation = (options?: Partial<Options<CreatePaymentData>>): UseMutationOptions<CreatePaymentResponse, CreatePaymentError, Options<CreatePaymentData>> => {
    const mutationOptions: UseMutationOptions<CreatePaymentResponse, CreatePaymentError, Options<CreatePaymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPayment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPaymentQueryKey = (options: Options<GetPaymentData>) => createQueryKey('getPayment', options);

export const getPaymentOptions = (options: Options<GetPaymentData>) => queryOptions<GetPaymentResponse, GetPaymentError, GetPaymentResponse, ReturnType<typeof getPaymentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPayment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPaymentQueryKey(options)
});

export const listCounterpartiesQueryKey = (options: Options<ListCounterpartiesData>) => createQueryKey('listCounterparties', options);

export const listCounterpartiesOptions = (options: Options<ListCounterpartiesData>) => queryOptions<ListCounterpartiesResponse, ListCounterpartiesError, ListCounterpartiesResponse, ReturnType<typeof listCounterpartiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCounterparties({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCounterpartiesQueryKey(options)
});

/**
 * Adds a recipient with a US bank account or a wallet. Requires two-factor authentication.
 */
export const createCounterpartyMutation = (options?: Partial<Options<CreateCounterpartyData>>): UseMutationOptions<CreateCounterpartyResponse, CreateCounterpartyError, Options<CreateCounterpartyData>> => {
    const mutationOptions: UseMutationOptions<CreateCounterpartyResponse, CreateCounterpartyError, Options<CreateCounterpartyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createCounterparty({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const archiveCounterpartyMutation = (options?: Partial<Options<ArchiveCounterpartyData>>): UseMutationOptions<ArchiveCounterpartyResponse, ArchiveCounterpartyError, Options<ArchiveCounterpartyData>> => {
    const mutationOptions: UseMutationOptions<ArchiveCounterpartyResponse, ArchiveCounterpartyError, Options<ArchiveCounterpartyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await archiveCounterparty({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCounterpartyQueryKey = (options: Options<GetCounterpartyData>) => createQueryKey('getCounterparty', options);

export const getCounterpartyOptions = (options: Options<GetCounterpartyData>) => queryOptions<GetCounterpartyResponse, GetCounterpartyError, GetCounterpartyResponse, ReturnType<typeof getCounterpartyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCounterparty({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCounterpartyQueryKey(options)
});

export const getPaymentLimitsQueryKey = (options: Options<GetPaymentLimitsData>) => createQueryKey('getPaymentLimits', options);

export const getPaymentLimitsOptions = (options: Options<GetPaymentLimitsData>) => queryOptions<GetPaymentLimitsResponse, GetPaymentLimitsError, GetPaymentLimitsResponse, ReturnType<typeof getPaymentLimitsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPaymentLimits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPaymentLimitsQueryKey(options)
});

/**
 * Prices each way to send a payment (rail, fee, arrival) without moving money.
 */
export const quotePaymentMutation = (options?: Partial<Options<QuotePaymentData>>): UseMutationOptions<QuotePaymentResponse, QuotePaymentError, Options<QuotePaymentData>> => {
    const mutationOptions: UseMutationOptions<QuotePaymentResponse, QuotePaymentError, Options<QuotePaymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await quotePayment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const approvePaymentMutation = (options?: Partial<Options<ApprovePaymentData>>): UseMutationOptions<ApprovePaymentResponse, ApprovePaymentError, Options<ApprovePaymentData>> => {
    const mutationOptions: UseMutationOptions<ApprovePaymentResponse, ApprovePaymentError, Options<ApprovePaymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await approvePayment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const rejectPaymentMutation = (options?: Partial<Options<RejectPaymentData>>): UseMutationOptions<RejectPaymentResponse, RejectPaymentError, Options<RejectPaymentData>> => {
    const mutationOptions: UseMutationOptions<RejectPaymentResponse, RejectPaymentError, Options<RejectPaymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rejectPayment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const cancelPaymentMutation = (options?: Partial<Options<CancelPaymentData>>): UseMutationOptions<CancelPaymentResponse, CancelPaymentError, Options<CancelPaymentData>> => {
    const mutationOptions: UseMutationOptions<CancelPaymentResponse, CancelPaymentError, Options<CancelPaymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cancelPayment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOnboardingQueryKey = (options: Options<GetOnboardingData>) => createQueryKey('getOnboarding', options);

export const getOnboardingOptions = (options: Options<GetOnboardingData>) => queryOptions<GetOnboardingResponse, GetOnboardingError, GetOnboardingResponse, ReturnType<typeof getOnboardingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOnboarding({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOnboardingQueryKey(options)
});

/**
 * Saves a draft. Masked or empty SSN/EIN values keep what was stored.
 */
export const saveOnboardingMutation = (options?: Partial<Options<SaveOnboardingData>>): UseMutationOptions<SaveOnboardingResponse, SaveOnboardingError, Options<SaveOnboardingData>> => {
    const mutationOptions: UseMutationOptions<SaveOnboardingResponse, SaveOnboardingError, Options<SaveOnboardingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveOnboarding({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const uploadOnboardingDocumentMutation = (options?: Partial<Options<UploadOnboardingDocumentData>>): UseMutationOptions<UploadOnboardingDocumentResponse, UploadOnboardingDocumentError, Options<UploadOnboardingDocumentData>> => {
    const mutationOptions: UseMutationOptions<UploadOnboardingDocumentResponse, UploadOnboardingDocumentError, Options<UploadOnboardingDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadOnboardingDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const submitOnboardingDocumentsMutation = (options?: Partial<Options<SubmitOnboardingDocumentsData>>): UseMutationOptions<SubmitOnboardingDocumentsResponse, SubmitOnboardingDocumentsError, Options<SubmitOnboardingDocumentsData>> => {
    const mutationOptions: UseMutationOptions<SubmitOnboardingDocumentsResponse, SubmitOnboardingDocumentsError, Options<SubmitOnboardingDocumentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await submitOnboardingDocuments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const submitOnboardingMutation = (options?: Partial<Options<SubmitOnboardingData>>): UseMutationOptions<SubmitOnboardingResponse, SubmitOnboardingError, Options<SubmitOnboardingData>> => {
    const mutationOptions: UseMutationOptions<SubmitOnboardingResponse, SubmitOnboardingError, Options<SubmitOnboardingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await submitOnboarding({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
